import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { useSelector, useDispatch } from 'react-redux';
import history from '../../history';
import { checkNotifications } from '../../actions/userActions';
import moment from 'moment';
import 'moment/locale/ja';
import Spinner from '../common/Spinner';

Modal.setAppElement("#root")

const styles = {
    container: {
        maxWidth: "700px",
        margin: "0 auto",
        padding: "2rem",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        fontFamily: "inherit",
    },
    heading: {
        fontSize: "2rem",
        fontWeight: "bold",
        margin: "2rem 0",
        color: "#26344a",
    },
    notificationList: {
        marginTop: "2rem",
    },
    notificationItem: {
        background: "#f5f5f5",
        borderRadius: "6px",
        padding: "1.2rem 1.5rem",
        marginBottom: "1.2rem",
        cursor: "pointer",
        border: "1px solid #e0e0e0",
        transition: "background 0.2s, border-color 0.2s",
        fontSize: "1.1rem",
        color: "#26344a",
        display: "flex",
        flexDirection: "column",
    },
    notificationItemHover: {
        background: "#e8f0fe",
        borderColor: "#3273dc",
    },
    notificationItemChecked: {
        opacity: 0.6,
    },
    textWrap: {
        wordBreak: "break-word",
        whiteSpace: "pre-line",
    },
    date: {
        marginTop: "0.5rem",
        color: "#3273dc",
        fontSize: "1rem",
    }
};

const Notifications = () => {
    const user = useSelector(state => state.user.currentUser);
    const notifications = useSelector(state => state.user.notifications);
    const loading = useSelector(state => state.common.loading);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            //Make all notification to be checked
            dispatch(checkNotifications());
        };
    }, [dispatch])

    const handleClick = notification => {
        switch (notification.notificationType) {
            case "like":
                history.push('/profiles/' + notification.recordId);
                break;
            case "comment":
                history.push('/thread/' + notification.recordId);
                break;
            default:
                break;
        }
    }

    // Local state to handle hover effect
    const [hoveredIdx, setHoveredIdx] = React.useState(null);

    const renderNotifications = () => {
        if (!notifications || notifications.length === 0)
            return <div>お知らせはありません</div>;

        let userNotifications = [...notifications];

        return userNotifications.map((notification, index) => {
            const isChecked = notification.checked;
            const isHover = hoveredIdx === index && notification.recordId;
            return (
                <div
                    key={index}
                    style={{
                        ...styles.notificationItem,
                        ...(isHover ? styles.notificationItemHover : {}),
                        ...(isChecked ? styles.notificationItemChecked : {})
                    }}
                    onClick={() => handleClick(notification)}
                    onMouseEnter={() => setHoveredIdx(index)}
                    onMouseLeave={() => setHoveredIdx(null)}
                >
                    <div style={styles.textWrap}>{notification.message}</div>
                    <p style={styles.date}>{moment(notification.created_at).utc().fromNow()}</p>
                </div>
            )
        })
    }

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>お知らせ一覧</h1>
            <div style={styles.notificationList}>
                {loading ? <Spinner /> : renderNotifications()}
            </div>
        </div>
    )
}

export default Notifications
